// Função para extrair parâmetros UTM da URL
export const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {
    utm_source: urlParams.get('utm_source'),
    utm_medium: urlParams.get('utm_medium'),
    utm_campaign: urlParams.get('utm_campaign'),
    utm_id: urlParams.get('utm_id'),
    utm_term: urlParams.get('utm_term'),
    utm_content: urlParams.get('utm_content'),
  };

  // Remover campos vazios, null ou undefined
  Object.keys(utmParams).forEach(key => 
    (utmParams[key] === null || utmParams[key] === undefined || utmParams[key] === '') && delete utmParams[key]
  );

  return Object.keys(utmParams).length > 0 ? utmParams : null;
};

// Função para salvar UTMs no localStorage
export const saveUtmParams = () => {
  const utmParams = getUtmParams();
  localStorage.setItem('utmParams', JSON.stringify(utmParams));
};

// Função para recuperar UTMs do localStorage
export const getStoredUtmParams = () => {
  const storedParams = localStorage.getItem('utmParams');
  return storedParams ? JSON.parse(storedParams) : null;
};
